import { HttpErrorResponse, HttpParams } from '@angular/common/http';
import { environment, Pricing } from 'src/environments/environment';
import { IUserProfile } from '../responses/iuser-profile';
import { IMenu } from '../responses/imenu';
import * as debug from 'src/app/shared/services/debug.service';
import { IPricing } from '../responses/ipricing';
import { ActivatedRouteSnapshot } from '@angular/router';
import { IScreenSize, ScreenSizes } from '../classes/screen-sizes';

export function filterMenuFromDbMenus(
	urlNoQuerystring: string,
	dbMenus: IMenu[]
): IMenu[] {
	const regEx = /\/(\d+)/g;
	const menus = dbMenus.filter((dbMenu) => {
		// replace the route value to match the pattern in module route configurations
		const revertedModuleRoute = urlNoQuerystring.replace(regEx, '/:id');
		const isEqual = revertedModuleRoute === dbMenu.routerLink;

		// debug.warn(`${dbMenu.routerLink} === ${origRoute}`);

		return isEqual;
	});

	return menus;
}

export function findMenuFromDbMenus(
	urlNoQuerystring: string,
	dbMenus: IMenu[]
): IMenu {
	// const menus = filterMenuFromDbMenus(urlNoQuerystring, dbMenus);

	// if (!!menus && menus.length > 0) {
	//     return menus[0];
	// }

	// return undefined;

	const regEx = /\/(\d+)/g;
	const menu = dbMenus.find((dbMenu) => {
		// replace the route value to match the pattern in module route configurations
		const revertedModuleRoute = urlNoQuerystring.replace(regEx, '/:id');
		const isEqual = revertedModuleRoute === dbMenu.routerLink;

		// debug.warn(`${dbMenu.routerLink} === ${origRoute}`);

		return isEqual;
	});

	return menu;
}

export function trimQueryString(routerLink: string): string {
	const routes = routerLink.split('?');
	const route = routes.length > 0 ? routes[0] : routerLink;

	// if (!!activatedRouteSnapshot) {

	//     const objParam = activatedRouteSnapshot.params;

	//     if (!isEmptyObject(objParam)) {

	//         for (const key in objParam) {

	//             if (objParam.hasOwnProperty(key)) {

	//                 const val = objParam[key];

	//                 debug.log(`=====trimQueryString key: ${key} val: ${val}`);

	//                 if (!!val) {

	//                     route = route.replace(`/${val}`, '');

	//                 }
	//             }
	//         }
	//     } else {

	//         debug.log(`=====trimQueryString params is empty! activatedRouteSnapshot:`, activatedRouteSnapshot);

	//     }
	// }

	return route;
}

export function getRootUrlSegment(routerLink: string): string {
	const urlSegments = getUrlSegments(routerLink);

	if (urlSegments.length > 0) {
		return `/${urlSegments[0]}`;
	}

	return '/';
}

export function getUrlSegments(routerLink: string): string[] {
	const routes = routerLink.split('/');

	if (routes.length <= 1) {
		return [];
	}

	return routes.slice(1, routes.length);
}

export function isValidImageType(type: string): boolean {
	return /image\/(png|jpg|jpeg|bmp|gif|tiff|svg)/.test(type);
}

export function parseErrorMessage(error: any): string {
	if (navigator.onLine) {
		return error.message ? error.message : error.toString();
	}

	return 'No Internet Connection';
}

export function isEmptyObject(obj: any): boolean {
	if (!obj) {
		return true;
	}

	for (const prop in obj) {
		if (obj.hasOwnProperty(prop)) {
			return false;
		}
	}

	return true;
}

export function base64ToFile(base64Image: string): Blob {
	const split = base64Image.split(',');
	const type = split[0].replace('data:', '').replace(';base64', '');
	const byteString = atob(split[1]);
	const ab = new ArrayBuffer(byteString.length);
	const ia = new Uint8Array(ab);
	for (let i = 0; i < byteString.length; i += 1) {
		ia[i] = byteString.charCodeAt(i);
	}
	return new Blob([ab], { type });
}

export const defaultMenuId = 0;
export const defaultHomeMenuId = 1;
export const fallbackMenu: IUserProfile = {
	id: defaultMenuId,
	givenName: '',
	email: '',
	familyName: '',
	nickname: '',
	name: '',
	isActive: false,
	emailVerified: true,
	pictureUrl: '',
	phone: '',
	zipcode: '',
	country: '',
	state: '',
	roles: [],
	recommendedLogin: '',
	loginProvider: '',
	menus: [
		{
			title: 'Landing Page',
			header: 'Landing Page',
			routerLink: '/root',
			id: 1,
			parentId: defaultMenuId,
			icon: 'supervisor_account',
			desc:
			'Trackinator implements the official Angular Material Design components and built with Angular CLI. No Bootstrap!, No jQuery! and Only TypeScript!',
			hasSubMenu: true,
			isHorizontalMenu: true,
			allowInFavoritesNav: true,
			isRootModule: true,
			menuOrientation: 'horizontal',
		},
		{
			title: 'Home',
			header: 'Home',
			routerLink: '/',
			id: 2,
			parentId: 1,
			icon: 'important_devices',
			desc:
				'Trackinator implements the official Angular Material Design components and built with Angular CLI. No Bootstrap!, No jQuery! and Only TypeScript!',
			hasSubMenu: true,
			isHorizontalMenu: true,
			isRootModule: true,
			menuOrientation: 'horizontal',
		},
		{
			title: 'Features',
			header: 'Great Features and Benefits',
			routerLink: '/features',
			id: 21,
			parentId: 2,
			icon: 'loyalty',
			desc:
				'Here are even more ways Trackinator can help you boost your business.',
			hasSubMenu: false,
			isHorizontalMenu: true,
			menuOrientation: 'horizontal',
		},
		{
			title: 'Pricing',
			header: 'Plans and Pricing',
			routerLink: '/pricing',
			id: 17,
			parentId: 2,
			icon: 'add_shopping_cart',
			desc: 'Choose the plan that\'s best for your business',
			hasSubMenu: false,
			isHorizontalMenu: true,
			menuOrientation: 'horizontal',
		},
		{
			title: 'Contact Us',
			header: 'Contact Us',
			routerLink: '/contact',
			id: 16,
			parentId: 2,
			icon: 'contact_mail',
			desc:
				'Feel free to drop us a line and We\'ll get back to you in 24 hours!',
			hasSubMenu: false,
			isHorizontalMenu: true,
			menuOrientation: 'horizontal',
		},
	],
	pricing: Pricing,
};

export function delay(ms: number): Promise<void> {
	return new Promise<void>((resolve) => setTimeout(resolve, ms));
}

export function getHomeUrl(activeModule: IMenu): string {
	if (activeModule) {
		let homeUrl = activeModule.routerLink;

		if (homeUrl === '/root') {
			homeUrl = '/';
		}

		return homeUrl;
	} else {
		return '/';
	}
	// return '/';
}

export function isMobileWindow(): boolean {
	return window && window.innerWidth <= 960;
}

export function getWindowSize(): IScreenSize {

	const windowWidth = window.innerWidth;
	const item = ScreenSizes.items.find(i => windowWidth >= i.begin && windowWidth <= i.end);

	return item;
}

/** Creates http query strings. */
export function toHttpParams(objParam: object): HttpParams {
	let params = new HttpParams();
	if (!objParam) {
		return params;
	}

	for (const key in objParam) {
		if (objParam.hasOwnProperty(key)) {
			const val = objParam[key];
			// debug.warn(`===== 02 toHttpParams key: ${key} val:`);
			// debug.warn(val);
			if (!!val) {
				params = params.append(key, val.toString());
			}
		}
	}
	return params;
}

export function getProperties(objParam: object): string[] {
	if (!objParam) {
		return [];
	}

	const props = [];

	for (const key in objParam) {
		if (objParam.hasOwnProperty(key)) {
			props.push(key);
		}
	}

	return props;
}

export function getCurrentWindowBaseUrl(): string {
	return `${window.location.origin}`;
}

export function getCurrentWindowUrl(): string {
	return `${window.location}`;
}

/** Uppercase the first letter. */
export function uppercaseFirst(s: string): string {
	if (typeof s !== 'string') {
		return '';
	}
	if (!s) {
		return '';
	}
	return s.charAt(0).toUpperCase() + s.slice(1);
}

/** Uses the last small letter before the capital letter as an indicator. */
export function toSpaceDelimitedWords(word: string): string {
	const regEx = /([a-z](?=[A-Z])|[A-Z](?=[A-Z][a-z]))/g;
	if (typeof word !== 'string') {
		return '';
	}
	if (!word) {
		return '';
	}
	let result = word.replace(/\s\s+/, ' '); // remove double spaces
	result = uppercaseFirst(result);
	return result.replace(regEx, '$1 '); // add space before the capital letter
}


export function createGenericObject<T>(type: (new () => T)): T {
	return new type();
}